declare var global: Window | undefined;


export const windowIfDefined = global as Window || null;
